import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'

const OrderItemRightUI = ({context, messageList, item}) =>
  <div className='g_flex_v g_text_right'>
    <div className='g_small'>
      {item.rateF2}<br />
      <MessageUI messageList={messageList} messageKey='c_qty' />:{' '}
      {item.quantity}
    </div>
    <div className='g_m_top_100'>{item.amountF2}</div>
  </div>

export default OrderItemRightUI
